import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import {
    loadFavoriteNids,
    loadFavoritesCruiseData,
    removeFromFavorites,
    setFavoritesShareLink,
} from '../../actions/favoritesPageActions';
import { clearFilterParams, doNewSearchViaUrl } from '../../actions/searchActions';
import { HeartFilledIcon } from '../../components/Icons/HeartFilledIcon';
import { ShareArea } from '../../components/Share/ShareArea/ShareArea';
import { config } from '../../config';
import { IFavoritePageReducer } from '../../reducers/favoritePage';
import { FAQContact } from '../FAQ/components/FAQContact';
import { SearchResultItem } from '../Search/components/SearchResultItem/SearchResultItem';
import { Header } from './components/Header';
import { NoFavorites } from './components/NoFavorites';

const FavoritesWrapperStyled = styled.div`
    padding: 15;

    .searchPageResultWrapper {
        margin-top: 30px;
    }
`;

const HeartFilledIconStyled = styled(HeartFilledIcon)`
    color: ${({ theme }) => theme.colors.watermelon[100]};
`;

const RemoveFromFavoriteButton = styled.button<{ withPackage: boolean }>`
    position: absolute;
    top: ${({ withPackage }) => (withPackage ? '54px' : '5px')};
    right: 5px;
    padding: 4px;
    border: none;
    background-color: transparent;
`;

const ResultWrapperStyled = styled.div`
    position: relative;
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.02);
    margin-bottom: 20px;
`;
interface StateProps {
    favoritePage: IFavoritePageReducer;
    contactPagePath: string;
    portalId: string;
    deviceType: string;
    phoneNumber: string;
    countryCode: string;
    favorites: number[];
    searchPageType: 'map' | 'destination' | 'ship' | 'mapWithNoUGC';
}

interface DispatchProps {
    doNewSearchViaUrl: () => void;
    clearFilterParams: () => void;
    removeFromFavorites(nid: number, updateShareLink: boolean): () => void;
    setFavoritesShareLink(favorites: number[]);
    loadFavoritesCruiseData: () => Promise<any>;
    loadFavoriteNids: () => void;
    discountThreshold: number;
}

type Props = StateProps & DispatchProps;

class FavoritePageClass extends React.Component<Props, any> {
    deleteFromFavorites = (e, cruiseNid) => {
        this.props.removeFromFavorites(cruiseNid, true);
    };

    componentDidMount() {
        this.props.loadFavoriteNids();
        this.props
            .loadFavoritesCruiseData()
            .then(this.props.setFavoritesShareLink(this.props.favoritePage.favorites));
    }

    renderResults = () => {
        if (
            this.props.favoritePage.favoritesCruiseData &&
            this.props.favoritePage.favoritesCruiseData.length > 0
        ) {
            return this.props.favoritePage.favoritesCruiseData.map((cruise, index) => (
                <ResultWrapperStyled key={index}>
                    {this.props.deviceType === 'mobile' && (
                        <RemoveFromFavoriteButton
                            withPackage={cruise.isPackageCruise}
                            onClick={(e) => this.deleteFromFavorites(e, cruise.cruiseNid)}
                        >
                            <HeartFilledIconStyled />
                        </RemoveFromFavoriteButton>
                    )}
                    <SearchResultItem
                        cruise={cruise}
                        hideFavoritesIcon={this.props.deviceType === 'mobile'}
                        portalId={this.props.portalId}
                        discountThreshold={this.props.discountThreshold}
                        searchPageType={this.props.searchPageType}
                        isFavorite={this.props.favorites.indexOf(cruise.cruiseNid) > -1}
                        removeFromFavorites={(cruiseNid: number) =>
                            this.props.removeFromFavorites(cruiseNid, true)
                        }
                    />
                </ResultWrapperStyled>
            ));
        }
    };

    render() {
        return this.props.favoritePage.favorites.length > 0 ? (
            <>
                <Header
                    title={this.props.favoritePage.title}
                    content={this.props.favoritePage.content}
                    hasOverlay={true}
                    styleHeader={{
                        backgroundImage: `url(${config.images}/common/faq_contact_background.jpg)`,
                        height: 177,
                    }}
                />
                <FavoritesWrapperStyled>
                    <ShareArea
                        emailShareLink={this.props.favoritePage.emailShareLink}
                        socialShareLink={this.props.favoritePage.socialShareLink}
                    />
                    <div className="container searchPage">
                        <div className="row">
                            <div className="searchPageFilterWrapper">
                                {this.props.deviceType === 'desktop' && (
                                    <FAQContact
                                        countryCode={this.props.countryCode}
                                        phoneNumber={this.props.phoneNumber}
                                        contactPageUrl={this.props?.contactPagePath}
                                    />
                                )}
                            </div>
                            <div className="searchPageResultWrapper">{this.renderResults()}</div>
                        </div>
                    </div>
                </FavoritesWrapperStyled>
            </>
        ) : (
            <NoFavorites
                deviceType={this.props.deviceType}
                doNewSearchViaUrl={this.props.doNewSearchViaUrl}
                clearFilterParams={this.props.clearFilterParams}
            />
        );
    }
}

// @TODO Fix state type inconsistency
const mapStateToProps = (state: StateProps) => ({
    favoritePage: state.favoritePage,
    portalId: (state as any).pageData.appConfig.portalId,
    contactPagePath: (state as any)?.pageData?.brandConfig?.contactPagePath,
    discountThreshold: (state as any).pageData.discountThreshold,
    deviceType: (state as any).pageData.deviceType,
    searchPageType: (state as any).search.searchPageType,
    phoneNumber: (state as any).pageData.brandConfig.phoneNumber,
    countryCode: (state as any).pageData.appConfig.countryCode,
    favorites: (state as any).favoritePage.favorites,
});

const mapDispatchToProps = {
    doNewSearchViaUrl,
    clearFilterParams,
    removeFromFavorites,
    setFavoritesShareLink,
    loadFavoritesCruiseData,
    loadFavoriteNids,
};

// @TODO: Fix dispatch props
export const FavoritePage = connect<StateProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
)(FavoritePageClass);

export default FavoritePage;
